import { useState } from "react";

const faqs = [
  {
    q: "How do I get an expedited passport in Great Falls, Montana?",
    a: "Great Falls residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Seattle, 490+ miles west via I-90.",
  },
  {
    q: "Where is the nearest passport agency to Great Falls, MT?",
    a: "The Seattle Regional Passport Agency (915 2nd Ave Suite 500, Seattle, WA 98101) is approximately 490 miles west of Great Falls via I-90. It requires an appointment for emergencies only. Fast Passport Center eliminates that trip for Cascade County residents.",
  },
  {
    q: "Can Malmstrom AFB personnel use Fast Passport Center?",
    a: "Yes — Fast Passport Center serves all Great Falls residents including military personnel and their families stationed at Malmstrom AFB. Our mail-in service works perfectly for service members who need expedited civilian passports.",
  },
  {
    q: "Can I renew my passport by mail from Great Falls?",
    a: "Yes! Adults who meet the DS-82 renewal eligibility requirements can renew entirely by mail. Fast Passport Center provides overnight shipping labels, reviews your documents, and handles the full submission process.",
  },
  {
    q: "How long does expedited passport processing take from Great Falls?",
    a: "With Fast Passport Center, most Great Falls customers receive their passport in 2–9 business days. Routine post-office expedited processing takes 3–5 weeks, while standard mail-in takes 6–11 weeks.",
  },
  {
    q: "Where can I apply for a new passport in Great Falls?",
    a: "First-time applicants must visit a passport acceptance facility in person. Great Falls options include the Main Post Office (215 1st Ave N) and the West Station (3500 10th Ave S). Fast Passport Center helps schedule your visit.",
  },
  {
    q: "What documents do I need for a passport renewal in Great Falls?",
    a: "You'll need your most recent passport, a completed DS-82 form, a new passport photo, and the government fee payment. Fast Passport Center reviews all documents for accuracy before submission.",
  },
  {
    q: "How much does expedited passport service cost in Great Falls?",
    a: "Government fees apply regardless of which service you use ($130–$160). Fast Passport Center charges a service fee for document review, agency submission, and daily status updates — saving you the cost of a 980-mile Seattle round trip.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Great Falls Passport Questions — Answered
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Common questions from Great Falls and Cascade County residents about expedited passport services.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left bg-white hover:bg-[#F7F8FA] transition-colors cursor-pointer"
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <i className={`${openIndex === i ? "ri-subtract-line" : "ri-add-line"} text-[#F6C344] text-lg flex-shrink-0`}></i>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5 bg-[#F7F8FA] border-t border-gray-100">
                  <p className="text-gray-600 text-sm leading-relaxed pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}